<template>
    <div>
        <!-- Invoice Template -->
         <div id="downloadWaybill">
            <div class="d-flex justify-content-between">
                <div style="width: 212px;height: 64px;margin-top: 25px;color: #FFFFFF;background: #266423;">
                    <div style="width: 156px;height: 39px;margin-left: 76px;margin-top: 20px;">Zhulia</div>
                </div>
                <div style="width: 136px;height: 44px;margin-left: 429px;margin-top: 30px;font-weight: 600;font-size: 36px;line-height: 44px;text-align: right;letter-spacing: 0.05em;color: #6F6F84;">Waybill</div>
            </div>
            <div class="d-flex justify-content-between">
                <div>
                    <br>
                    <h3 style="width: 354px;height: 35px;font-weight: 500;font-size: 24px;line-height: 29px;color: #000000;">{{ data.sourceLocationName }}  </h3>
                    <!-- <p style="width: 242px;height: 17px;font-weight: normal;font-size: 14px;line-height: 17px;color: #6F6F84;">Accra, Ghana</p>
                    <p style="width: 242px;height: 17px;font-weight: 600;font-size: 14px;line-height: 17px;margin-top:30px;color: #222234;">{{ data.cowtribeDate ? data.cowtribeDate : 'N/A'}}</p> -->
                </div>
                <div>
                    <!-- <p style="width: 58px;height: 17px;margin-left: 507px;font-size: 14px;line-height: 17px;text-align: right;color: #6F6F84;">Billed to,</p> -->
                    <p style="width: 100%;font-weight: 600;font-size: 14px;line-height: 17px;text-align: right;color: #222234;">{{ data.destinationLocationName }}</p>
                    <!-- <div style="width: 126px;height: 60px;margin-left: 439px;font-size: 12px;line-height: 25px;text-align: right;color: #222234;">
                        {{ data.retailerAddress ? data.retailerAddress : 'N/A'}}
                    </div>
                    <div style="height: 60px;margin-left: 439px;margin-top: -28px;font-weight: 600;font-size: 12px;line-height: 25px;text-align: right;color: #222234;">
                        {{ data.phoneNumber ? data.phoneNumber : 'N/A'}}
                    </div> -->
                </div>
            </div>
            <div style="margin-top:20px">
                 <hr style="border: 1px solid #C7C7C7;">
            </div>
            <div>
                <div class="d-flex justify-content-between mx-3">
                    <div>
                        <div style="font-size: 14px;line-height: 17px;color: #6F6F84;">Waybill number</div>
                        <div style="font-weight: 600;font-size: 14px;line-height: 17px;color: #222234;padding-top:10px">{{ data.requestId ? `#${data.requestId}` : 'N/A'}}</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;line-height: 17px;color: #6F6F84;">Requested By</div>
                        <div style="font-weight: 600;font-size: 14px;line-height: 17px;color: #222234;padding-top:10px">{{ data.requestedBy ? `${data.requestedBy}` : 'N/A'}}</div>
                    </div>
                    <div>
                        <div style="font-size: 14px;line-height: 17px;color: #6F6F84;">Expected At</div>
                        <div style="font-weight: 600;font-size: 14px;line-height: 17px;color: #222234;padding-top:10px">{{ data.expectedAt ? data.expectedAt : 'N/A'}}</div>
                    </div>
                </div>
            </div>
            <div>
                 <hr style="border: 1px solid #C7C7C7;">
            </div>
                <div style="margin-top:30px">
                     <table class="table table-striped table-hover table-bordered fixed_header">
                        <thead>
                            <tr>
                            <th scope="col">Product Name</th>
                            <th scope="col">Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in data.fulfillmentLines" :key="product.productId">
                                <td>{{ product.productBrandName }}</td>
                                <td>{{ product.quantity }}</td>
                            </tr> 
                        </tbody>
                    </table>
                </div>
                <div style="margin-top:20px" class="d-flex justify-content-between">
                    <p style="font-weight: 600;font-size: 16px;line-height: 16px;letter-spacing: 0.05em;color: #6F6F84;">Total Products(s)</p>
                    <p style="font-weight: bold;font-size: 16px;line-height: 15px;color: #222234;">{{ displayTotalQuantity }}</p>
                </div>
                <div style="height: 12px;font-weight: 500;margin-top:20px;font-size: 14px;line-height: 12px;letter-spacing: 0.05em;color: #6F6F84;">
                    <p style="font-weight: 500;font-size: 14px;line-height: 12px;letter-spacing: 0.05em;color: #6F6F84;">Terms & Conditions</p>
                    This invoice should be paid ASAP. Please find the account number below
                </div>
                
                <div class="d-flex justify-content-between">
                    <div style="margin-top: 60px;">
                        <div style="height: 15px;font-weight: 500;font-size: 15px;line-height: 15px;letter-spacing: 0.05em;color: #6F6F84;">Bank Account Details</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:10px;line-height: 17px;color: #6F6F84;">Company Name: Tribeco Trading Limited</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:20px;line-height: 17px;color: #6F6F84;">Account Number:  6011114970</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:30px;line-height: 17px;color: #6F6F84;">Bank Branch:  Zenith Bank, Tamale</div>
                    </div>

                    <div style="margin-top: 60px;">
                        <div style="height: 15px;font-weight: 500;font-size: 15px;line-height: 15px;letter-spacing: 0.05em;color: #6F6F84;">Momo Merchant</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:10px;line-height: 17px;color: #6F6F84;">Momo Number: 0559691061</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:20px;line-height: 17px;color: #6F6F84;">Merchant ID: 020161</div>
                        <div style="height: 17px;font-weight: 600;font-size: 16px;padding-top:30px;line-height: 17px;color: #6F6F84;">Merchant Name: TribeCo Limited</div>
                    </div>
                </div>

                <div style="position: fixed;bottom: 0;width: 100%;">
                     <div>
                        <hr style="border: 1px solid #C7C7C7;">
                    </div>

                    <div class="d-flex justify-content-between">
                        <div style="width: 100px;height: 17px;font-size: 14px;line-height: 17px;color: #418A49;">www.zhulia.me</div>
                        <div style="width: 110px;height: 17px;font-size: 14px;line-height: 17px;color: #6F6F84;">sales@zhulia.me</div>
                        <div style="height: 17px;font-size: 14px;line-height: 17px;color: #6F6F84;">+233559691061</div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'WaybillDownload',
        data(){
            return{
                previewModalVisible: false,
                data: {
                    destinationLocationName: '',
                    expectedAt:'',
                    requestId: '',
                    requestedBy: '',
                    total:'',
                    sourceLocationName: '',
                    fulfillmentLines: [],
                }
            }
        },
        computed: {
            displayTotalQuantity(){
                // console.log("in tableData |", this.tableData)
                const itemQuantity = this.data.fulfillmentLines.map(item => {
                    if(item.quantity){
                        return parseInt(item.quantity) 
                    }else{
                        return 0
                    }
                })
                // console.log("in each itemAmount |", itemQuantity)
                const totalQuantity = itemQuantity.reduce((acc, item) => acc + item, 0);
                // console.log("in computed totalAmt |", totalQuantity)
                return parseInt(totalQuantity)
            },
        },
        methods:{
            handlePreviewModalCancel(){
                this.previewModalVisible = false
            },
            downloadWaybill(previewData){
                this.data = previewData
                setTimeout(() =>  this.$htmlToPaper('downloadWaybill'), 1000);
            }
        },
        watch: {
            data(newValue) {
                this.data = newValue
            }
        }
    }
</script>

<style scoped>
.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.invoiceContainer{
    height: 842px;
    position: relative;
    background: #FFFFFF;
}

#downloadWaybill{
    display: none;
}

.divider-2{
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 300px;
}

.divider-3{
    position: absolute;
    width: 535px;
    height: 0px;
    left: 30px;
    top: 806px;
}

.tableFixHead {
        overflow-y: auto;
        height: 200px;
      }
.tableFixHead thead th {
position: sticky;
top: 0;
}
.tableFixHead table {
border-collapse: collapse;
width: 100%;
}
.tableFixHead th,
.tableFixHead td {
padding: 8px 16px;
border: 1px solid #ccc;
}
.tableFixHead th {
background: #eee;
}
.subTotal{
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 599px;
}

.subTotal p:first-of-type{
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:last-of-type{
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.ant-divider-horizontal {
    border: 1px solid #C7C7C7;
}

</style>